import React, { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Plus } from "react-feather";
import { Link, useLocation } from 'react-router-dom';
import { Container, DropdownItem, Row } from "reactstrap";
import SharedDataContext from "../../../_helper/SharedData";
import { Breadcrumbs, Btn, Spinner } from "../../../AbstractElements";
import { Admin } from "../../../Data/SideMenu/RouteMapping";
import { vendorFilterColums, vendorListColumns } from "../../../Data/Vendor/VendorList";
import { formatDateString, getUserRole } from "../../../Services/Shared.service";
import { getvendorsFilter, getVendorsList, getVendorsSearch, vendorIdToLocalStorage } from "../../../Services/Ventor.service";
import ActionOptions from "../../Common/Component/ActionOptions";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import CreateVendor from "./createVendor";
import CustomSelectFilter from "./CustomSelectFilter";
import DeleteConfirmationModal from "./vendorDeleteConfirmationModal";
import SelectedFilter from "../../TripManagement/BookingHistory/SelectedFilter";
const VendorList = () => {
  const userRole = getUserRole()
  const location = useLocation();
  const { cityData, globalCityField,setShowApiLoader, setPageNumber , dateFilter} =
  useContext(SharedDataContext);
  const [pagination, setPagination] = useState(location.state?.pageNumber ? location.state.pageNumber : 0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isRefresh, setIsRefresh] = useState(false);
  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [createVendorModal, setCreateVendorModal] = useState(false)
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [loader, setLoader] = useState(false);
  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : []);

  console.log(">>>> PAGINATION VALUE IS ::: ", location.state?.pageNumber)

  const [editId, setEditId] = useState("")
  const [driverObj, setDriverObj] = useState({});
  const togglecreateVendor = () =>
    setCreateVendorModal(!createVendorModal);
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () =>
    setDeleteModal(!deleteModal);

    const [levelMenu, setLevelMenu] = useState(false);
    const columns = vendorFilterColums.map((element) => {
        return {  value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name, };
      });

      let filterFromLocation = location.state?.filterdata?.length > 0 ? location.state?.filterdata.map((d)=>{
        if(d?.key == "Pickup"){
          return {
            ...d,
            key: <span>
            <Fragment>
              PICKUP <i className="fa fa-clock-o mr-2"></i>
            </Fragment>
          </span>
          }
        }else {
          return d
        }
      }) : []
    
      useEffect(() => {
        setPageNumber(0);
      });

  const [filterData, setFilterData] = useState(filterFromLocation);
    const removeFilter = (index) => {
        const newfilterData = [...filterData];
        newfilterData.splice(index, 1);
        setFilterData(newfilterData);
      };

      // ----------------------table view
       const [tableData, setTableData] = useState([]);
      // ---------------------------table list 

   

      const processData=tableData.map((element,index)=>{
        return {
            vendor: <Link onClick={()=>{
              localStorage.setItem('prevLink','vendor/vendor-list');
              vendorIdToLocalStorage(element.companyName, tableData);
            }} to={`${process.env.PUBLIC_URL}/vendor/vendor-profile/${element.companyName}`} >{element.companyName}</Link>,
            contact_name:element.contactPersonName,
            phone_number:element.mobile,
            address:element.addressLine,
            registered_date:element.createdOn? formatDateString(element.createdOn, "MMM DD,YYYY HH:mm") : '-',
            
            Deleted:element.isDeleted,
            action:<ActionOptions> <DropdownItem
            className="border-0"
            key={"row-edit"}
            onClick={() => {
              setEditId(element.id);
              setPageNumber(pagination)
              togglecreateVendor();
            }}
            state={{ previousUrl: window.location.pathname, filterdata: filterData, searchdata: searchData }}
          >
            <i className="fa fa-pencil"></i> Edit
          </DropdownItem>
          {userRole.some((element) =>  element == Admin) ? <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setDriverObj(element);
          toggleDeleteModal()
        }}
      >
        <i className="fa fa-trash"></i> {element.isDeleted ? "Recover" : "Delete"}
      </DropdownItem> : null}
      </ActionOptions>
        }  })

        useEffect(() => {
          fetchTableData();
        }, [globalCityField.value, pagination, rowsPerPage, isRefresh,searchData]);
        
        useEffect(() => {
          if (filterData.length == 0 && filterType != "filter") return;
          fetchTableData();
        }, [filterData]);
        const fetchTableData = () => {

          const serviceCityId = globalCityField.value?.id || 0;
          if (filterData.length == 0 && !searchData) {
            let obj = {
              serviceCityId: serviceCityId,
              page: pagination ,
              size: rowsPerPage,
            };
      

            getVendorsList(obj).then((res)=>{
            console.log("responss  ---",res)
            if(res.data){
              setTableData(res.data.list)
              setPaginationTotalRows(res.data.count)
            }
          }).catch((err)=>{
            console.log(err)
          })
        }else  if (filterData.length > 0 && filterType == "filter") {
          let obj = {
            serviceCityId: serviceCityId,
            page: pagination ,
            size: pagination.rowsPerPage,
          };
          
          filterData.forEach((d) => {
            // console.log("filterData",filterData)
            obj[d.column_name] = d["values"][0];
          });

             getvendorsFilter(obj).then((res)=>{
              console.log("responss  ---",res)
              if(res.data){
                setTableData(res.data.filterResponse)
                setPaginationTotalRows(res.data.count)
              }
            }).catch((err)=>{
              console.log(err)
            })
        }else if (searchData && filterType == "search"){
         
          let obj = {
            serviceCityId: serviceCityId,
            page: pagination ,
            size: rowsPerPage,
            searchData:searchData
          };
          getVendorsSearch(obj).then((res)=>{
            console.log("responss  ---",res)
            if(res.data){
              setTableData(res.data.list)
              setPaginationTotalRows(res.data.count)
            }
          }).catch((err)=>{
            console.log(err)
          })


        }
        }
        console.log("filterData",filterData)
        // ---------------helpers
        const onChangePage = (page) => {
          console.log("page", page);
          setPagination(page - 1);
        };
        const onChangeRowsPerPage = (currentRowsPerPage) => {
          setRowsPerPage(currentRowsPerPage);
        };
        const triggerRefresh = () => {
          setIsRefresh(!isRefresh);
        };
        const conditionalRowStyles = [

          {
            when: row => row["Deleted"] ,
            style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
          },
      ];



  return (
    <Fragment>
      <Breadcrumbs
        parent="Vendor"
        mainTitle="Vendor"
        span2={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setFilterType={setFilterType}
            setSearchData={setSearchData}
          />
        }
        span1={
          userRole.some(
            (element) => element == Admin 
        ) ? <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: togglecreateVendor }}>
            <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
          </Btn> : null
        }
        span3={<SearchTable
          searchData={searchData}
          setSearchData={setSearchData}
          setFilterData={setFilterData}
          setFilterType={setFilterType}
          placeholder={"Search with Phone No "} 
          />}
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <div className="filter-body">
                <div
                  className="filtered-data"
                  key={i}
                  onClick={() => setLevelMenu(!levelMenu)}
                >
                  <i
                  onClick={() => removeFilter(i)}
                  className="fa fa-times-circle"
                ></i>
                  <span className="filtered-name">{element.key}</span>
                  <span className="badge rounded-pill badge-primary">
                    {element.values.length}
                  </span>
                  <i className="fa fa-angle-down"></i>
                </div>
                <ul
                  className="header-level-menu menu-to-be-close"
                  style={levelMenu ? { display: "" } : { display: "none" }}
                >
                  <li className="border-0" key={"filter-data"}>
                  <CustomSelectFilter columnValue={element.values}/>
                  </li>
                </ul>
              </div>
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
          {/* {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })} */}
        </Row>
        <Row>
          {/* <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <VendorTable />
              </CardBody>
            </Card>
          </Col> */}
            <div className="table-responsive">
          <DataTable
          columns={vendorListColumns}
          data={processData}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationDefaultPage={location.state?.pageNumber
            ? location.state.pageNumber + 1
            : 1}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          progressPending={loader}
          triggerRefresh={triggerRefresh}
          conditionalRowStyles={conditionalRowStyles}
          pageNumber={
            location.state?.pageNumber
                ? location.state.pageNumber + 1
                : 1
        }
          progressComponent={
            <div className="loader-box" style={{ height: "57vh" }}>
              <Spinner
                attrSpinner={{
                  className: "loader-3",
                  style: {
                    width: "30px",
                    height: "30px",
                    borderColor: "#39B54A",
                    borderBottomColor: "transparent",
                  },
                }}
              />
            </div>
          }
          /></div>
        </Row>
      </Container>


      
      <CreateVendor 
       Large={createVendorModal}
       title={editId ? "Update Vendor" : "Create Vendor"}
      // title="Create vendor"
       LargeModaltoggle={() => {
         setEditId("")
        //  fetchDriverData({ isSearchFilterPage: pagination });
        togglecreateVendor()
        // triggerRefresh()
       }}
       cityDataList={cityData}
      //  setShowApiLoader={setShowApiLoader}
       editId={editId}
      />
        <DeleteConfirmationModal
        Large={deleteModal}
        title={"Delete Vendor"}
        LargeModaltoggle={toggleDeleteModal}
        fetchData={fetchTableData}
        driverObj={driverObj}
      />
    </Fragment>
  )
}

export default VendorList